import ApplicationTableActions from '@/containers/applications/table/actions'
import { TApplication } from '@/interfaces'
import { ApplicationsState } from '@/state'

export default function CurrentApplicationInfo() {
  return (
    <div className='application-id'>
      <div className='id-title'>IDENTIFICADOR DE SOLICITUD</div>
      <div className='id-value'>
        {ApplicationsState.currentApplication.value?.id as string}
      </div>
      <div className='status-value'>
        {ApplicationsState.currentApplication.value?.estadoName as string}
      </div>
      <ApplicationTableActions
        rowInfo={ApplicationsState.currentApplication.value as TApplication}
      />
    </div>
  )
}
